import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, Box } from '@mui/material/';
import { trakrefBlue } from '../../../color_utils';

const LoadingBar = ({
    stylish,
    paddingTop,
}) => {
    const [progress, setProgress] = useState(0);
    const [buffer, setBuffer] = useState(10);
    const progressRef = useRef(() => {});

    useEffect(() => {
        progressRef.current = () => {
            if (progress > 100) {
            setProgress(0);
            setBuffer(10);
            } else {
            const diff = Math.random() * 10;
            const diff2 = Math.random() * 10;
            setProgress(progress + diff);
            setBuffer(progress + diff + diff2);
            }
        };
    });

    useEffect(() => {
        const timer = setInterval(() => {
          progressRef.current();
        }, 500);
    
        return () => {
          clearInterval(timer);
        };
    }, []);

    if (stylish) {
        return (
            <Box sx={{ width: '80%', marginLeft: 'auto', marginRight: 'auto', paddingTop: paddingTop }}>
                <LinearProgress
                    variant="buffer"
                    value={progress}
                    valueBuffer={buffer}
                />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '80%', marginLeft: 'auto', marginRight: 'auto', paddingTop: paddingTop }}>
            <LinearProgress
                sx={{ '& .MuiLinearProgress-bar': { backgroundColor: trakrefBlue } }}
            />
        </Box>
    );
};

LoadingBar.propTypes = {
    stylish: PropTypes.bool,
    paddingTop: PropTypes.number,
};

LoadingBar.defaultProps = {
    stylish: false,
    paddingTop: 50
};

export default LoadingBar;
